<p-select
  [fluid]="true"
  [formControl]="control"
  [options]="selectItems"
  [showClear]="true"
  emptyMessage="Brak opcji do wyboru."
  placeholder="Wybierz wartość">
  <ng-template
    #item
    let-option>
    {{ option.label }}
  </ng-template>
</p-select>
